module.exports = __webpack_public_path__ + "static/media/image-12.3c4e745b.avif";